import React from 'react';
import { connect } from 'react-redux';
import AppRouter, { history } from '../routers/AppRouter';
//Actions
import { startLogout } from '../actions/auth';
//Components
import Balance from './Balance';
import Clans from './Clans';
import Contributions from './Contributions';
import ContributionsForm from './ContributionsForm';
import Log from './Log';
import Nav from 'locki-dashboard-navigation/dist/navigation';
import Notice from './Notice';
//Icons
import Assignment from '@material-ui/icons/Assignment';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Notifications from '@material-ui/icons/Notifications';
import People from '@material-ui/icons/People';
//Img
import logo from '../img/logo_dark.svg';

class Main extends React.Component {
  handleItemClick = (itemPath) => {
    history.push(itemPath);
  };
  render() {
    const airtable = this.props.airtable || {};
    const items = [
      { component: Clans, label: 'FAMILIAS', icon: <People />, path: '/' },
      {
        component: Notice,
        label: 'MENSAJERIA',
        icon: <Notifications />,
        path: '/aviso',
      },
    ];
    items.push({
      component: Log,
      label: 'REGISTRO',
      icon: <Assignment />,
      path: '/registro',
    });
    if (airtable.balance) {
      items.push({
        component: Balance,
        label: 'SALDOS',
        icon: <MonetizationOn />,
        path: '/saldos',
      });
    }
    if (airtable.contributions) {
      items.push({
        component: Contributions,
        label: 'APORTACIONES',
        icon: <MonetizationOn />,
        path: '/aportaciones',
      });
    }
    if (airtable.contributionsForm) {
      items.push({
        component: ContributionsForm,
        label: 'COBRANZA',
        icon: <MonetizationOn />,
        path: '/cobranza',
      });
    }
    return (
      <Nav
        items={items}
        component={<AppRouter items={items} />}
        currentPath={window.location.pathname}
        handleItemClick={this.handleItemClick}
        handleLogout={this.props.startLogout}
        logo={logo}
        title={this.props.placeName}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  airtable: state.place.airtable,
  placeName: state.place ? state.place.name : '',
});

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
